import styled from "styled-components"

export const DownloadButton = styled.button`
  margin-left: 0.75rem;
  color: var(--clr-text-blue);
  border: none;
  background: none;
  cursor: pointer;
  font-weight: 700;
`
